import {
  MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE,
  MAIN_PAGE_WORKSPACE_SEGMENT_SELECTED_STYLE,
  MAIN_PAGE_WORKSPACE_SEGMENT_TRACK_STYLE,
} from "../theme/mainPageVisual";

type CognitoryWorkspaceNavProps = {
  mode: "ask" | "library" | "activity";
  showActivity: boolean;
  onSelectAsk: () => void;
  onSelectLibrary: () => void;
  onSelectActivity: () => void;
};

export default function CognitoryWorkspaceNav({
  mode,
  showActivity,
  onSelectAsk,
  onSelectLibrary,
  onSelectActivity,
}: CognitoryWorkspaceNavProps) {
  return (
    <div
      data-testid="cognitory-workspace-nav"
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "0.85rem",
      }}
    >
      <div
        data-testid="cognitory-workspace-nav-track"
        style={MAIN_PAGE_WORKSPACE_SEGMENT_TRACK_STYLE}
      >
        <button
          type="button"
          data-testid="cognitory-workspace-nav-cog"
          aria-pressed={mode === "ask"}
          style={
            mode === "ask"
              ? {
                  ...MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE,
                  ...MAIN_PAGE_WORKSPACE_SEGMENT_SELECTED_STYLE,
                }
              : MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE
          }
          onClick={onSelectAsk}
        >
          Cog
        </button>
        <button
          type="button"
          data-testid="cognitory-workspace-nav-library"
          aria-pressed={mode === "library"}
          style={
            mode === "library"
              ? {
                  ...MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE,
                  ...MAIN_PAGE_WORKSPACE_SEGMENT_SELECTED_STYLE,
                }
              : MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE
          }
          onClick={onSelectLibrary}
        >
          Library
        </button>
        {showActivity ? (
          <button
            type="button"
            data-testid="cognitory-workspace-nav-activity"
            aria-pressed={mode === "activity"}
            style={
              mode === "activity"
                ? {
                    ...MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE,
                    ...MAIN_PAGE_WORKSPACE_SEGMENT_SELECTED_STYLE,
                  }
                : MAIN_PAGE_WORKSPACE_SEGMENT_BUTTON_STYLE
            }
            onClick={onSelectActivity}
          >
            Review
          </button>
        ) : null}
      </div>
    </div>
  );
}
